import { apiClient } from './apiClient';

export interface Subscription {
  id: string;
  status: string;
  priceId: string;
  currentPeriodEnd: string;
  cancelAtPeriodEnd: boolean;
}

export interface Plan {
  id: string;
  name: string;
  stripePriceId: string;
  amount: number;
  currency: string;
  interval: string;
}

export interface CheckoutResponse {
  url: string;
}

export const paymentService = {
  // Create a checkout session
  createCheckoutSession: async (priceId: string): Promise<CheckoutResponse> => {
    const response = await apiClient.post('/payments/checkout', { priceId });
    return response.data;
  },

  // Get billing portal URL
  getPortalUrl: async (): Promise<CheckoutResponse> => {
    const response = await apiClient.get('/payments/portal');
    return response.data;
  },

  // Get current subscription
  getSubscription: async (): Promise<Subscription | null> => {
    const response = await apiClient.get('/payments/subscription');
    return response.data;
  },

  // Get available subscription plans
  getSubscriptionPlans: async (): Promise<Plan[]> => {
    const response = await apiClient.get('/payments/subscription-plans');
    return response.data;
  },

  // Cancel at period end
  unsubscribe: async (): Promise<Subscription> => {
    const response = await apiClient.post('/payments/unsubscribe');
    return response.data;
  },
};
